/**
 * Поддерживает ли браузер event'ы с пассивным режимом
 * adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
 * @type {{update: (function())}}
 */
const detectPassiveEvents = {
  update () {
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      let passive = false;
      try {
        const options = Object.defineProperty({}, 'passive', {
          get () { passive = true; }
        });

        const noop = () => {};
        window.addEventListener('testPassiveEventSupport', noop, options);
        window.removeEventListener('testPassiveEventSupport', noop, options);
      } catch (e) {}

      detectPassiveEvents.hasSupport = passive;
    }
  }
};

detectPassiveEvents.update();
export default detectPassiveEvents;



// WEBPACK FOOTER //
// ./src/utils/detectPassiveEvents.js